import _ from 'lodash';
import dayjs from 'dayjs';

export const ENTIDADE_CUPOM = 'cupom_desconto';
export const ENTIDADE_ITEM = 'item_catalogo';

const RESPONSAVEL_LOJA = 'loja';
const RESPONSAVEL_REMOVIDO = 'removido';

const ACOES = {
  criacao: { label: 'Criação', icon: 'add', classe: 'criacao' },
  ativacao: { label: 'Ativação', icon: 'check', classe: 'ativacao' },
  desativacao: { label: 'Desativação', icon: 'power_settings_new', classe: 'desativacao' },
  alteracao: { label: 'Alteração de status', icon: 'swap_horiz', classe: 'alteracao' },
};

const VERBOS = {
  [ENTIDADE_ITEM]: {
    criacao: 'Criada',
    ativacao: 'Ativada',
    desativacao: 'Desativada',
  },
  [ENTIDADE_CUPOM]: {
    criacao: 'Criado',
    ativacao: 'Ativado',
    desativacao: 'Desativado',
  },
};

const STATUS_ITEM = {
  1: 'Pendente',
  2: 'Aprovado',
  3: 'Cancelado',
};

const isVazio = valor => valor === null || valor === undefined;
const labelStatus = status => STATUS_ITEM[status] || `Status ${status}`;
const labelAtivo = ativo => (Number(ativo) === 1 ? 'Sim' : 'Não');

function transicao(anterior, atual, label) {
  if (isVazio(atual)) {
    return null;
  }
  if (isVazio(anterior)) {
    return { atual: label(atual) };
  }
  if (Number(anterior) === Number(atual)) {
    return null;
  }
  return { anterior: label(anterior), atual: label(atual) };
}

function detalhesLog(log) {
  const isItem = log.entidade === ENTIDADE_ITEM;
  const detalhes = [];

  if (isItem) {
    const status = transicao(log.status_anterior, log.status_atual, labelStatus);
    if (status) {
      detalhes.push({ campo: 'Status', ...status });
    }
  }

  if (isItem || log.acao === 'criacao') {
    const ativo = transicao(log.ativo_anterior, log.ativo_atual, labelAtivo);
    if (ativo) {
      detalhes.push({ campo: 'Ativo', ...ativo });
    }
  }

  return detalhes;
}

function responsavelLog(log) {
  if (log.responsavel_tipo === RESPONSAVEL_LOJA) {
    return {
      tipo: RESPONSAVEL_LOJA,
      nome: log.responsavel_nome || 'Usuário da loja',
      email: log.responsavel_email || null,
      icon: 'person',
    };
  }
  if (log.responsavel_tipo === RESPONSAVEL_REMOVIDO) {
    return { tipo: RESPONSAVEL_REMOVIDO, nome: 'Usuário removido', email: null, icon: 'person_outline' };
  }
  return { tipo: 'sistema', nome: 'Sistema', email: null, icon: 'settings' };
}

function labelDia(data) {
  const diff = dayjs().startOf('day').diff(data.startOf('day'), 'day');
  if (diff === 0) {
    return 'Hoje';
  }
  if (diff === 1) {
    return 'Ontem';
  }
  return data.format('DD/MM/YYYY');
}

export function formatarQuando(dataLog) {
  const data = dayjs(dataLog);
  return `${labelDia(data).toLowerCase()} às ${data.format('HH:mm')}`;
}

export function formatarLog(log) {
  const data = dayjs(log.data);
  return {
    id: log.id,
    data,
    hora: data.format('HH:mm'),
    acao: ACOES[log.acao] || ACOES.alteracao,
    detalhes: detalhesLog(log),
    responsavel: responsavelLog(log),
  };
}

export function resumirLog(log) {
  const responsavel = responsavelLog(log);
  const verbos = VERBOS[log.entidade] || {};
  return {
    acao: verbos[log.acao] || 'Status alterado',
    preposicao: responsavel.tipo === 'sistema' ? 'pelo' : 'por',
    autor: responsavel.tipo === RESPONSAVEL_REMOVIDO ? 'usuário removido' : responsavel.nome,
    quando: formatarQuando(log.data),
  };
}

export function agruparPorDia(logs) {
  return logs.map(formatarLog).reduce((grupos, log) => {
    const chave = log.data.format('YYYY-MM-DD');
    const ultimo = grupos[grupos.length - 1];
    if (ultimo && ultimo.chave === chave) {
      ultimo.logs.push(log);
    } else {
      grupos.push({ chave, label: labelDia(log.data), logs: [log] });
    }
    return grupos;
  }, []);
}

export async function buscarUltimasAlteracoes(axios, { entidade, estabelecimentoId }) {
  const { data } = await axios.get('/log-ativacao', {
    params: {
      entidade,
      estabelecimento_id: estabelecimentoId,
      ultimo: 1,
    },
  });
  return _.keyBy(data || [], 'entidade_id');
}

export default {
  ENTIDADE_CUPOM,
  ENTIDADE_ITEM,
  formatarQuando,
  formatarLog,
  resumirLog,
  agruparPorDia,
  buscarUltimasAlteracoes,
};
